export default __webpack_public_path__ + "static/media/FathersDayBackgroundMobile.ff83abb5.png";